module.exports = __webpack_public_path__ + "static/img/32.a92cacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/32.png
// module id = yzzm
// module chunks = 0